import React from "react";
import Container from "react-bootstrap/Container";
import Typist from 'react-typist-component';
import { Jumbotron } from "./migration";
import  backgroundImage from '../../assets/backgroundperson.png'
import {about} from "../../editable-stuff/config";

const MainBody = React.forwardRef(
  ({ gradient, title, message, icons }, ref) => {
    return (
      <Jumbotron
        fluid
        id="home"
        style={{
          // background: `linear-gradient(136deg,${gradient})`,
          // backgroundSize: "1200% 1200%",
            backgroundImage: `url(${backgroundImage})`, // 背景图片
            backgroundSize: "cover", // 图片覆盖整个背景
            backgroundPosition: "80% 50%", // 默认显示右侧背景
            // backgroundPosition: isMobile ? "right" : "center", // 动态调整位置
            backgroundRepeat: "no-repeat", // 防止图片重复

        }}
        className="title bg-transparent bgstyle text-light min-vh-100 d-flex align-content-center align-items-center flex-wrap m-0"
      >
        <div id="stars"></div>
        {/*<Container className="text-center">*/}
            <Container style={{paddingLeft:"4.5rem"}}>
          <h1 ref={ref} className="display-1">
            {title}
          </h1>
          <Typist>
            <div className="lead typist" style={{paddingLeft:"0.5rem"}}>
              {message}
            </div>
          </Typist>
          {/*<div className="p-5">*/}
          {/*    <div style={{paddingTop:"2rem",paddingBottom:"1.5rem",paddingRight:"2rem",paddingLeft:"0"}}>*/}
          {/*  {icons.map((icon, index) => (*/}
          {/*    <a*/}
          {/*      key={`social-icon-${index}`}*/}
          {/*      target="_blank"*/}
          {/*      rel="noopener noreferrer"*/}
          {/*      href={icon.url}*/}
          {/*      aria-label={`My ${icon.image.split("-")[1]}`}*/}
          {/*      onClick={(e) => e.preventDefault()}*/}
          {/*      style={{cursor:"not-allowed"}}*/}
          {/*    >*/}
          {/*      <i className={`fab ${icon.image}  fa-3x socialicons`} />*/}
          {/*    </a>*/}
          {/*  ))}*/}
          {/*</div>*/}
                <div style={{paddingLeft:"0.5rem",paddingTop:"0.5rem"}}>
          <a
            className="btn btn-outline-light btn-lg "
            href={about.resume}
            target="_blank"
            role="button"
            aria-label="Learn more about me"
          >
            Download resume
          </a></div>
        </Container>
      </Jumbotron>
    );
  }
);

export default MainBody;
